import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import {unbindOriginalSearch, updateSearchAria} from "./helpers"

import "./styles/index.css"


const selectorsToRemove = [
    'side-panel[name="search-panel"] div[data-search-results]', 'side-panel[name="search-panel"] div.mb-14',
    "#nostoTargetAutocomplete ul.list-none","#nostoTargetAutocomplete p.paragraph-3.uppercase"
]

selectorsToRemove.forEach(selector => {
    // console.log(document.querySelectorAll(selector));
    document.querySelectorAll(selector).forEach(el => el.remove());
})

const inputSelector = "#SearchAutocomplete";

// unbindOriginalSearch(inputSelector);

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: inputSelector,
    contentCssSelector: "#nostoTargetSERP",
    // contentCssSelector: "#MainContent",
    // dropdownCssSelector: "div[data-trending-searches]",
    dropdownCssSelector: "#nostoTargetAutocomplete",
    // formCssSelector: "#search-form",
    hitDecorators: [
        thumbnailDecorator({ size: "9" })
    ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "imageHash",
            //     "thumbUrl",
            //     "description",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            // ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '#nostoTargetPLP',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(()=>{
    console.log('Nosto Search initialized');
    if (window.innerWidth > 767) {
        const searchDiv = document.querySelector('[data-open-search] > div');
    
        if (searchDiv) {
            const handleClickOrKeyPress = (event) => {
                if (event.type === 'click') {
                    // event.preventDefault();
                    setTimeout(() => {
                        const input = document.querySelector(inputSelector);
                        if (input) {
                            input.click();
                        }
                    }, 100);
                } else if(event.type === 'keydown' && event.key === ' '){
                    // event.preventDefault();
                    setTimeout(() => {
                        const input = document.querySelector(inputSelector);
                        if (input) {
                            input.click();
                        }
                    }, 200);
                }
            };
        
            // Add event listeners for both click and keydown events
            searchDiv.addEventListener('click', handleClickOrKeyPress);
            searchDiv.addEventListener('keydown', handleClickOrKeyPress);
        }
    }

    const sideSearchPanel = document.querySelector('side-panel[name="search-panel"]');
    if(sideSearchPanel){
        sideSearchPanel.setAttribute('id', 'focus-trap');
    }

    const trap = document.getElementById('focus-trap');

    const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'textarea:not([disabled])',
        'input[type="text"]:not([disabled])',
        'input[type="radio"]:not([disabled])',
        'input[type="checkbox"]:not([disabled])',
        'select:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ];

    const focusableElements = trap.querySelectorAll(focusableSelectors.join(','));
    const firstEl = focusableElements[0];
    const lastEl = focusableElements[focusableElements.length - 1];

    trap.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
        if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
            }
        } else { // Tab
            if (document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
            }
        }
        }
    });

    // Optionally focus the first element when entering the trap
    trap.addEventListener('focus', () => {
        firstEl.focus();
    });

    // const nativeInput = document.querySelector(inputSelector);
    // if(nativeInput){
    //     nativeInput.setAttribute('aria-controls', "nosto-autocomplete-container nosto-history-container");
    // }
    updateSearchAria('history');
})
